import { EntityTable } from 'Dexie';
import { z } from 'zod';

export const PublicationTableSchema = z.object({
  processId: z.number(),
  documentId: z.number(),
  applicationId: z.number(),
  organicEntityId: z.number(),
  securityId: z.number(),
  userId: z.number(),
  dateIndex: z.string(),
  phase: z.number(),
  title: z.string(),
  message: z.string(),
  datePublication: z.string(),
  isExported: z.boolean(),
  sourceLocation: z.number(),
  sourceProcessId: z.number(),
  sourceDocumentId: z.number(),
})

export type PublicationTable = z.infer<typeof PublicationTableSchema>;
export type DexiePublicationTable = EntityTable<PublicationTable, 'documentId'>;
export const PublicationTableColumn = 'documentId, processId, applicationId, organicEntityId, securityId, userId, dateIndex, phase, title, message, datePublication, sourceLocation, sourceProcessId, isExported, sourceDocumentId';
